(function() {
    window.SU = window.SU || {};
    window.SU.validateInput = function(id) {
        const
            input = document.getElementById(id),
            form = input.form,
            validationBlock = document.getElementById(`${id}-validation-block`),
            validationMessage = document.getElementById(`${id}-validation-message`),
            problemText = validationMessage ? validationMessage.textContent : null,
            eventTypes = [
                'blur',
                'input'
            ];

        eventTypes.forEach((eventType) => {
            input.addEventListener(eventType, () => {
                if (input.validity.valid) {
                    hideError();
                } else {
                    showError();
                }
            });
        });

        form.addEventListener('submit', (event) => {
            if (!input.validity.valid) {
                showError();
                event.preventDefault();
            }
        });

        function hideError() {
            // console.debug(`${id} is valid (SU)`);
            input.classList.add('is-valid');
            input.classList.remove('is-invalid');
            if (validationBlock && validationMessage) {
                validationBlock.classList.add('d-none');
                validationMessage.textContent = '';
                // TODO aria-describedby
            }
        }

        function showError() {
            // console.debug(`${id} is invalid (SU)`);
            input.classList.add('is-invalid');
            input.classList.remove('is-valid');
            if (validationBlock && validationMessage) {
                // console.debug('found the validation block');
                validationBlock.classList.remove('d-none');
                validationMessage.textContent = problemText;
                // TODO aria-describedby
            } else {
                // console.error('Did *not* find the validation block');
            }
        }
    };
})();
